import _defineProperty from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { forwardRef, useState, useRef, useEffect } from 'react';
import { useUuid, useScrollIntoView, useUncontrolled, useDidUpdate, useMergedRef } from '@mantine/hooks';
import { getDefaultZIndex, useMantineDefaultProps, extractSystemStyles } from '@mantine/styles';
import { SelectScrollArea } from './SelectScrollArea/SelectScrollArea.js';
import { DefaultItem } from './DefaultItem/DefaultItem.js';
import { getSelectRightSectionProps } from './SelectRightSection/get-select-right-section-props.js';
import { SelectItems } from './SelectItems/SelectItems.js';
import { SelectDropdown } from './SelectDropdown/SelectDropdown.js';
import { filterData } from './filter-data/filter-data.js';
import useStyles from './Select.styles.js';
import { groupOptions } from '../../utils/group-options/group-options.js';
import { InputWrapper } from '../InputWrapper/InputWrapper.js';
import { Input } from '../Input/Input.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

function defaultFilter(value, item) {
  return item.label.toLowerCase().trim().includes(value.toLowerCase().trim());
}

function defaultShouldCreate(query, data) {
  return !!query && !data.some(function (item) {
    return item.label.toLowerCase() === query.toLowerCase();
  });
}

var defaultProps = {
  required: false,
  size: "sm",
  shadow: "sm",
  itemComponent: DefaultItem,
  transition: "fade",
  transitionDuration: 0,
  initiallyOpened: false,
  filter: defaultFilter,
  maxDropdownHeight: 220,
  searchable: false,
  clearable: false,
  limit: Infinity,
  disabled: false,
  creatable: false,
  shouldCreate: defaultShouldCreate,
  selectOnBlur: false,
  switchDirectionOnFlip: false,
  filterDataOnExactSearchMatch: false,
  zIndex: getDefaultZIndex("popover"),
  clearButtonTabIndex: 0,
  positionDependencies: []
};
var Select = forwardRef(function (props, ref) {
  var _a = useMantineDefaultProps("Select", defaultProps, props),
      className = _a.className,
      style = _a.style,
      required = _a.required,
      label = _a.label,
      id = _a.id,
      error = _a.error,
      description = _a.description,
      size = _a.size,
      shadow = _a.shadow,
      data = _a.data,
      value = _a.value,
      defaultValue = _a.defaultValue,
      onChange = _a.onChange,
      itemComponent = _a.itemComponent,
      onKeyDown = _a.onKeyDown,
      onBlur = _a.onBlur,
      onFocus = _a.onFocus,
      transition = _a.transition,
      transitionDuration = _a.transitionDuration,
      initiallyOpened = _a.initiallyOpened,
      transitionTimingFunction = _a.transitionTimingFunction,
      wrapperProps = _a.wrapperProps,
      classNames = _a.classNames,
      styles = _a.styles,
      filter = _a.filter,
      maxDropdownHeight = _a.maxDropdownHeight,
      searchable = _a.searchable,
      clearable = _a.clearable,
      nothingFound = _a.nothingFound,
      clearButtonLabel = _a.clearButtonLabel,
      limit = _a.limit,
      disabled = _a.disabled,
      onSearchChange = _a.onSearchChange,
      rightSection = _a.rightSection,
      rightSectionWidth = _a.rightSectionWidth,
      creatable = _a.creatable,
      getCreateLabel = _a.getCreateLabel,
      shouldCreate = _a.shouldCreate,
      selectOnBlur = _a.selectOnBlur,
      onCreate = _a.onCreate,
      sx = _a.sx,
      dropdownComponent = _a.dropdownComponent,
      onDropdownClose = _a.onDropdownClose,
      onDropdownOpen = _a.onDropdownOpen,
      withinPortal = _a.withinPortal,
      switchDirectionOnFlip = _a.switchDirectionOnFlip,
      zIndex = _a.zIndex,
      name = _a.name,
      dropdownPosition = _a.dropdownPosition,
      allowDeselect = _a.allowDeselect,
      errorProps = _a.errorProps,
      descriptionProps = _a.descriptionProps,
      labelProps = _a.labelProps,
      placeholder = _a.placeholder,
      filterDataOnExactSearchMatch = _a.filterDataOnExactSearchMatch,
      clearButtonTabIndex = _a.clearButtonTabIndex,
      form = _a.form,
      positionDependencies = _a.positionDependencies,
      others = __objRest(_a, ["className", "style", "required", "label", "id", "error", "description", "size", "shadow", "data", "value", "defaultValue", "onChange", "itemComponent", "onKeyDown", "onBlur", "onFocus", "transition", "transitionDuration", "initiallyOpened", "transitionTimingFunction", "wrapperProps", "classNames", "styles", "filter", "maxDropdownHeight", "searchable", "clearable", "nothingFound", "clearButtonLabel", "limit", "disabled", "onSearchChange", "rightSection", "rightSectionWidth", "creatable", "getCreateLabel", "shouldCreate", "selectOnBlur", "onCreate", "sx", "dropdownComponent", "onDropdownClose", "onDropdownOpen", "withinPortal", "switchDirectionOnFlip", "zIndex", "name", "dropdownPosition", "allowDeselect", "errorProps", "descriptionProps", "labelProps", "placeholder", "filterDataOnExactSearchMatch", "clearButtonTabIndex", "form", "positionDependencies"]);

  var _useStyles = useStyles(),
      classes = _useStyles.classes,
      cx = _useStyles.cx,
      theme = _useStyles.theme;

  var _extractSystemStyles = extractSystemStyles(others),
      systemStyles = _extractSystemStyles.systemStyles,
      rest = _extractSystemStyles.rest;

  var _useState = useState(initiallyOpened),
      _useState2 = _slicedToArray(_useState, 2),
      dropdownOpened = _useState2[0],
      _setDropdownOpened = _useState2[1];

  var _useState3 = useState(-1),
      _useState4 = _slicedToArray(_useState3, 2),
      hovered = _useState4[0],
      setHovered = _useState4[1];

  var inputRef = useRef();
  var dropdownRef = useRef();
  var itemsRefs = useRef({});

  var _useState5 = useState("column"),
      _useState6 = _slicedToArray(_useState5, 2),
      direction = _useState6[0],
      setDirection = _useState6[1];

  var isColumn = direction === "column";
  var uuid = useUuid(id);

  var _useScrollIntoView = useScrollIntoView({
    duration: 0,
    offset: 5,
    cancelable: false,
    isList: true
  }),
      scrollIntoView = _useScrollIntoView.scrollIntoView,
      targetRef = _useScrollIntoView.targetRef,
      scrollableRef = _useScrollIntoView.scrollableRef;

  var isDeselectable = allowDeselect === void 0 ? clearable : allowDeselect;

  var setDropdownOpened = function setDropdownOpened(opened) {
    if (dropdownOpened !== opened) {
      _setDropdownOpened(opened);

      var handler = opened ? onDropdownOpen : onDropdownClose;
      typeof handler === "function" && handler();
    }
  };

  var isCreatable = creatable && typeof getCreateLabel === "function";
  var createLabel = null;
  var formattedData = data.map(function (item) {
    return typeof item === "string" ? {
      label: item,
      value: item
    } : item;
  });
  var sortedData = groupOptions({
    data: formattedData
  });

  var _useUncontrolled = useUncontrolled({
    value: value,
    defaultValue: defaultValue,
    finalValue: null,
    onChange: onChange,
    rule: function rule(val) {
      return typeof val === "string" || val === null;
    }
  }),
      _useUncontrolled2 = _slicedToArray(_useUncontrolled, 3),
      _value = _useUncontrolled2[0],
      handleChange = _useUncontrolled2[1],
      inputMode = _useUncontrolled2[2];

  var selectedValue = sortedData.find(function (item) {
    return item.value === _value;
  });

  var _useState7 = useState((selectedValue == null ? void 0 : selectedValue.label) || ""),
      _useState8 = _slicedToArray(_useState7, 2),
      inputValue = _useState8[0],
      setInputValue = _useState8[1];

  var handleSearchChange = function handleSearchChange(val) {
    setInputValue(val);

    if (searchable && typeof onSearchChange === "function") {
      onSearchChange(val);
    }
  };

  var handleClear = function handleClear() {
    var _a2;

    handleChange(null);

    if (inputMode === "uncontrolled") {
      handleSearchChange("");
    }

    (_a2 = inputRef.current) == null ? void 0 : _a2.focus();
  };

  useEffect(function () {
    var newSelectedValue = sortedData.find(function (item) {
      return item.value === _value;
    });

    if (newSelectedValue) {
      handleSearchChange(newSelectedValue.label);
    } else if (!isCreatable || !_value) {
      handleSearchChange("");
    }
  }, [_value]);
  useEffect(function () {
    if (selectedValue && (!searchable || !dropdownOpened)) {
      handleSearchChange(selectedValue.label);
    }
  }, [selectedValue == null ? void 0 : selectedValue.label]);

  var handleItemSelect = function handleItemSelect(item) {
    if (isDeselectable && (selectedValue == null ? void 0 : selectedValue.value) === item.value) {
      handleChange(null);
      setDropdownOpened(false);
    } else {
      handleChange(item.value);

      if (item.creatable) {
        typeof onCreate === "function" && onCreate(item.value);
      }

      if (inputMode === "uncontrolled") {
        handleSearchChange(item.label);
      }

      setHovered(-1);
      setDropdownOpened(false);
      inputRef.current.focus();
    }
  };

  var filteredData = filterData({
    data: sortedData,
    searchable: searchable,
    limit: limit,
    searchValue: inputValue,
    filter: filter,
    filterDataOnExactSearchMatch: filterDataOnExactSearchMatch,
    value: _value
  });

  if (isCreatable && shouldCreate(inputValue, filteredData)) {
    createLabel = getCreateLabel(inputValue);
    filteredData.push({
      label: inputValue,
      value: inputValue,
      creatable: true
    });
  }

  var getNextIndex = function getNextIndex(index, nextItem, compareFn) {
    var i = index;

    while (compareFn(i)) {
      i = nextItem(i);
      if (!filteredData[i].disabled) return i;
    }

    return index;
  };

  useDidUpdate(function () {
    setHovered(getNextIndex(-1, function (index) {
      return index + 1;
    }, function (index) {
      return index < filteredData.length - 1;
    }));
  }, [inputValue]);
  var selectedItemIndex = _value ? filteredData.findIndex(function (el) {
    return el.value === _value;
  }) : 0;

  var handlePrevious = function handlePrevious() {
    setHovered(function (current) {
      var _a2;

      var nextIndex = getNextIndex(current, function (index) {
        return index - 1;
      }, function (index) {
        return index > 0;
      });
      targetRef.current = itemsRefs.current[(_a2 = filteredData[nextIndex]) == null ? void 0 : _a2.value];
      scrollIntoView({
        alignment: isColumn ? "start" : "end"
      });
      return nextIndex;
    });
  };

  var handleNext = function handleNext() {
    setHovered(function (current) {
      var _a2;

      var nextIndex = getNextIndex(current, function (index) {
        return index + 1;
      }, function (index) {
        return index < filteredData.length - 1;
      });
      targetRef.current = itemsRefs.current[(_a2 = filteredData[nextIndex]) == null ? void 0 : _a2.value];
      scrollIntoView({
        alignment: isColumn ? "end" : "start"
      });
      return nextIndex;
    });
  };

  var scrollSelectedItemIntoView = function scrollSelectedItemIntoView() {
    return window.setTimeout(function () {
      var _a2;

      targetRef.current = itemsRefs.current[(_a2 = filteredData[selectedItemIndex]) == null ? void 0 : _a2.value];
      scrollIntoView({
        alignment: isColumn ? "end" : "start"
      });
    }, 0);
  };

  var handleInputKeydown = function handleInputKeydown(event) {
    typeof onKeyDown === "function" && onKeyDown(event);

    switch (event.nativeEvent.code) {
      case "ArrowUp":
        {
          event.preventDefault();

          if (!dropdownOpened) {
            setHovered(selectedItemIndex);
            setDropdownOpened(true);
            scrollSelectedItemIntoView();
          } else {
            isColumn ? handlePrevious() : handleNext();
          }

          break;
        }

      case "ArrowDown":
        {
          event.preventDefault();

          if (!dropdownOpened) {
            setHovered(selectedItemIndex);
            setDropdownOpened(true);
            scrollSelectedItemIntoView();
          } else {
            isColumn ? handleNext() : handlePrevious();
          }

          break;
        }

      case "Home":
        {
          if (!searchable) {
            event.preventDefault();

            if (!dropdownOpened) {
              setDropdownOpened(true);
            }

            var firstItemIndex = filteredData.findIndex(function (item) {
              return !item.disabled;
            });
            setHovered(firstItemIndex);
            scrollIntoView({
              alignment: isColumn ? "end" : "start"
            });
          }

          break;
        }

      case "End":
        {
          if (!searchable) {
            event.preventDefault();

            if (!dropdownOpened) {
              setDropdownOpened(true);
            }

            var lastItemIndex = filteredData.map(function (item) {
              return !!item.disabled;
            }).lastIndexOf(false);
            setHovered(lastItemIndex);
            scrollIntoView({
              alignment: isColumn ? "end" : "start"
            });
          }

          break;
        }

      case "Escape":
        {
          event.preventDefault();
          setDropdownOpened(false);
          setHovered(-1);
          break;
        }

      case "Space":
        {
          if (!searchable) {
            if (filteredData[hovered] && dropdownOpened) {
              event.preventDefault();
              handleItemSelect(filteredData[hovered]);
            } else {
              setDropdownOpened(true);
              setHovered(selectedItemIndex);
              scrollSelectedItemIntoView();
            }
          }

          break;
        }

      case "Enter":
        {
          if (!searchable) {
            event.preventDefault();
          }

          if (filteredData[hovered] && dropdownOpened) {
            event.preventDefault();
            handleItemSelect(filteredData[hovered]);
          }
        }
    }
  };

  var handleInputBlur = function handleInputBlur(event) {
    typeof onBlur === "function" && onBlur(event);
    var selected = sortedData.find(function (item) {
      return item.value === _value;
    });

    if (selectOnBlur && filteredData[hovered] && dropdownOpened) {
      handleItemSelect(filteredData[hovered]);
    }

    handleSearchChange((selected == null ? void 0 : selected.label) || "");
    setDropdownOpened(false);
  };

  var handleInputFocus = function handleInputFocus(event) {
    typeof onFocus === "function" && onFocus(event);

    if (searchable) {
      setDropdownOpened(true);
      scrollSelectedItemIntoView();
    }
  };

  var handleInputChange = function handleInputChange(event) {
    handleSearchChange(event.currentTarget.value);

    if (clearable && event.currentTarget.value === "") {
      handleChange(null);
    }

    setHovered(0);
    setDropdownOpened(true);
  };

  var handleInputClick = function handleInputClick() {
    var dropdownOpen = true;

    if (!searchable) {
      dropdownOpen = !dropdownOpened;
    }

    setDropdownOpened(dropdownOpen);

    if (_value && dropdownOpen) {
      setHovered(selectedItemIndex);
      scrollSelectedItemIntoView();
    }
  };

  var shouldShowDropdown = filteredData.length > 0 ? dropdownOpened : dropdownOpened && !!nothingFound;
  return /* @__PURE__ */React.createElement(InputWrapper, __spreadValues(__spreadValues({
    required: required,
    id: uuid,
    label: label,
    error: error,
    description: description,
    size: size,
    className: className,
    style: style,
    classNames: classNames,
    styles: styles,
    __staticSelector: "Select",
    sx: sx,
    errorProps: errorProps,
    descriptionProps: descriptionProps,
    labelProps: labelProps
  }, systemStyles), wrapperProps), /* @__PURE__ */React.createElement("div", {
    role: "combobox",
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(uuid, "-items"),
    "aria-controls": uuid,
    "aria-expanded": shouldShowDropdown,
    onMouseLeave: function onMouseLeave() {
      return setHovered(-1);
    },
    tabIndex: -1
  }, /* @__PURE__ */React.createElement("input", {
    type: "hidden",
    name: name,
    value: _value || "",
    form: form
  }), /* @__PURE__ */React.createElement(Input, __spreadValues(__spreadProps(__spreadValues({
    autoComplete: "nope"
  }, rest), {
    type: "text",
    required: required,
    ref: useMergedRef(ref, inputRef),
    id: uuid,
    invalid: !!error,
    size: size,
    onKeyDown: handleInputKeydown,
    __staticSelector: "Select",
    value: inputValue,
    placeholder: placeholder,
    onChange: handleInputChange,
    "aria-autocomplete": "list",
    "aria-controls": shouldShowDropdown ? "".concat(uuid, "-items") : null,
    "aria-activedescendant": hovered !== -1 ? "".concat(uuid, "-").concat(hovered) : null,
    onClick: handleInputClick,
    onBlur: handleInputBlur,
    onFocus: handleInputFocus,
    readOnly: !searchable,
    disabled: disabled,
    "data-mantine-stop-propagation": shouldShowDropdown,
    name: null,
    classNames: __spreadProps(__spreadValues({}, classNames), {
      input: cx(_defineProperty({}, classes.input, !searchable), classNames == null ? void 0 : classNames.input)
    })
  }), getSelectRightSectionProps({
    theme: theme,
    rightSection: rightSection,
    rightSectionWidth: rightSectionWidth,
    styles: styles,
    size: size,
    shouldClear: clearable && !!selectedValue,
    clearButtonLabel: clearButtonLabel,
    onClear: handleClear,
    error: error,
    clearButtonTabIndex: clearButtonTabIndex
  }))), /* @__PURE__ */React.createElement(SelectDropdown, {
    referenceElement: inputRef.current,
    mounted: shouldShowDropdown,
    transition: transition,
    transitionDuration: transitionDuration,
    transitionTimingFunction: transitionTimingFunction,
    uuid: uuid,
    shadow: shadow,
    maxDropdownHeight: maxDropdownHeight,
    classNames: classNames,
    styles: styles,
    ref: useMergedRef(dropdownRef, scrollableRef),
    __staticSelector: "Select",
    dropdownComponent: dropdownComponent || SelectScrollArea,
    direction: direction,
    onDirectionChange: setDirection,
    switchDirectionOnFlip: switchDirectionOnFlip,
    withinPortal: withinPortal,
    zIndex: zIndex,
    dropdownPosition: dropdownPosition,
    positionDependencies: positionDependencies
  }, /* @__PURE__ */React.createElement(SelectItems, {
    data: filteredData,
    hovered: hovered,
    classNames: classNames,
    styles: styles,
    isItemSelected: function isItemSelected(val) {
      return val === _value;
    },
    uuid: uuid,
    __staticSelector: "Select",
    onItemHover: setHovered,
    onItemSelect: handleItemSelect,
    itemsRefs: itemsRefs,
    itemComponent: itemComponent,
    size: size,
    nothingFound: nothingFound,
    creatable: isCreatable && !!createLabel,
    createLabel: createLabel,
    "aria-label": label
  }))));
});
Select.displayName = "@mantine/core/Select";
export { Select, defaultFilter, defaultShouldCreate };